import React from 'react';
import Navbar from './global-components/navbar-v3';
import PageHeader from './global-components/page-header';
import ContactForm from './section-components/contact-form';
import Footer from './global-components/footer';

const ContactPage = () => {
    return <div>
        <Navbar />
        <PageHeader from="contact" headertitle="Contact"  />
        <ContactForm />
        <Footer />
    </div>
}

export default ContactPage

